import { SessionStorageKeys } from "../types/enums/Storage.enum";
import { sessionStore } from "./Const.utils";

/**
 * Llaves que versiones anteriores guardaban en localStorage (compartido entre pestañas).
 * Ya no se leen; se eliminan para no dejar datos del flujo en el navegador
 */
const LLAVES_RECEPCION_LOCALSTORAGE_ANTERIORES = ['recepcionData', 'recepcionFormValues', 'queryAlguacil', 'recepcionFijaAudiencia'];

/**
 * Elimina del storage los datos del flujo de depósito (recepción) de caso/trámite.
 * Se usa al salir del formulario y al iniciar un flujo nuevo, para no arrastrar datos de un flujo anterior
 */
export const limpiarStorageRecepcion = () => {
    sessionStore.remove(SessionStorageKeys.RECEPCION_DATA);
    sessionStore.remove(SessionStorageKeys.RECEPCION_FORM_VALUES);
    sessionStore.remove(SessionStorageKeys.ALGUACIL);
    sessionStore.remove(SessionStorageKeys.RECEPCION_FIJA_AUDIENCIA);
    sessionStore.remove(SessionStorageKeys.RECEPCION_STEPPER_STATE);
    sessionStore.remove(SessionStorageKeys.RECEPCION_LOCATION_STATE);
    sessionStore.remove(SessionStorageKeys.RECEPCION_OPERACION_EN_CURSO);

    try {
        LLAVES_RECEPCION_LOCALSTORAGE_ANTERIORES.forEach((key) => localStorage.removeItem(key));
    } catch (error) {
        console.error('Error removiendo datos desde localStorage:', error);
    }
};
